/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardSeverity {
    getFixupPrototypeFunction() { return SecurityDashboardSeverity.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardSeverity>): SecurityDashboardSeverity {
        let obj = Object.assign(new SecurityDashboardSeverity(), model);
        SecurityDashboardSeverity.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardSeverity>): SecurityDashboardSeverity {
        if (!model) return null;
        return SecurityDashboardSeverity.newInstance(<SecurityDashboardSeverity> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardSeverity) {
        if (!obj) return;

        models.SecurityDashboardSeverity.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardSeverity): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardSeverity.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.critical === undefined) {
            this.critical = 0;
        }
        if (this.high === undefined) {
            this.high = 0;
        }
        if (this.medium === undefined) {
            this.medium = 0;
        }
        if (this.low === undefined) {
            this.low = 0;
        }
        if (this.none === undefined) {
            this.none = 0;
        }
        if (this.info === undefined) {
            this.info = 0;
        }
        if (this.unknown === undefined) {
            this.unknown = 0;
        }
    }

    /**
     * Critical Total Count
     */
    critical: number;

    /**
     * High Total Count
     */
    high: number;

    /**
     * Medium Total Count
     */
    medium: number;

    /**
     * Low Total Count
     */
    low: number;

    /**
     * None Total Count
     */
    none: number;

    /**
     * Info Total Count
     */
    info: number;

    /**
     * Unknown Total Count
     */
    unknown: number;

}
